
import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import { Helmet } from 'react-helmet';

import user from '../../assets/user.jpeg';
import Dashboardmy from '../Dashboard-component/Dashboard';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getWithTokenAPI } from '../../util/Api';
import { ToastContainer, toast } from 'react-toastify';
import { FaRegAddressBook } from "react-icons/fa";
import 'react-toastify/dist/ReactToastify.css';
import './order.css';
import { HiOutlineChevronRight, HiOutlineChevronLeft } from "react-icons/hi";
function Dashboard() {
    const [userData, setUserData] = useState({
        name: '',
        email: '',
        phone_number: '',
        profile_image: '',
        address: {
            street: '',
            city: '',
            state: '',
            zip_code: '',
            country: ''
        }
    });
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const accessToken = useSelector((state) => state.auth?.auth?.access_token);
    const userid = useSelector((state) => state.auth?.auth?._id);
    const username = useSelector((state) => state.auth?.auth?.name);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);

        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    useEffect(() => {
        if (!accessToken) {
            toast.error('Please login to access dashboard');
            navigate('/login');
            return;
        }
        fetchUserData();
        fetchOrders();
        fetchAddress();
    }, [accessToken]);


    const fetchUserData = async () => {
        try {
            setLoading(true);
            const response = await getWithTokenAPI(accessToken, `/user/find-particular?_id=${userid}`);
            if (response?.statusCode === 200 && response.data) {
                const user = response.data;
                setUserData({
                    name: user.name || '',
                    email: user.email || '',
                    phone_number: user.phone_number || '',
                    profile_image: user.profile_image || '',
                    address: {
                        street: user.street || '',
                        city: user.city || '',
                        state: user.state || '',
                        zip_code: user.zip_code || '',
                        country: user.country || ''
                    }
                });
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
            toast.error('Failed to fetch user data');
            if (error?.response?.status === 401) {
                navigate('/login');
            }
        } finally {
            setLoading(false);
        }
    };

    const fetchOrders = async () => {
        try {
            const response = await getWithTokenAPI(accessToken, `/order/find-all?buyer_id=${userid}`);
            if (response?.statusCode === 200 && response.data?.orders) {
                setOrders(response.data.orders);
            } else {
                console.error('Invalid response format:', response);
                toast.error('Failed to fetch orders: Invalid response format');
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
            if (error?.response?.status === 401) {
                toast.error('Session expired. Please login again');
                navigate('/login');
            } else {
                toast.error('Failed to fetch orders. Please try again later');
            }
        }
    };

    const fetchAddress = async () => {
        try {
            const response = await getWithTokenAPI(accessToken, `/address/find-all?user_id=${userid}`);
            if (response?.statusCode === 200 && response.data?.address?.length > 0) {
                const address = response.data.address[0]; // Get the first address
                setUserData(prevData => ({
                    ...prevData,
                    address: {
                        street: address.street || '',
                        city: address.city || '',
                        state: address.state || '',
                        zip_code: address.zip_code || '',
                        country: address.country || ''
                    }
                }));
            }
        } catch (error) {
            console.error('Error fetching address:', error);
            toast.error('Failed to fetch address information');
            if (error?.response?.status === 401) {
                navigate('/login');
            }
        }
    };

    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return 'Invalid Date';
            }
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (error) {
            console.error('Error formatting date:', error);
            return 'Invalid Date';
        }
    };

    // const getStatusClass = (status) => {
    //     if (!status) return '';
    //     const statusLower = status.toLowerCase();
    //     switch (statusLower) {
    //         case 'pending':
    //             return 'pending';
    //         case 'shipped':
    //             return 'shipped';
    //         case 'delivered':
    //             return 'delivered';
    //         default:
    //             return '';
    //     }
    // };
       const getStatusClass = (status) => {
        if (!status) return '';
        const statusLower = status.toLowerCase();
        switch (statusLower) {
            case 'pending':
                return 'status-pending'; // Renamed to be more descriptive
            case 'shipped':
                return 'status-shipped'; // Renamed
            case 'delivered':
                return 'status-delivered'; // Renamed
            case 'paid': // Add this new case for "Paid" status
                return 'status-paid';
            default:
                return '';
        }
    };


    const ordersPerPage = isMobile ? 3 : 4;
    const totalPages = Math.ceil(orders.length / ordersPerPage);
    const startIndex = (currentPage - 1) * ordersPerPage;
    const currentOrders = orders.slice(startIndex, startIndex + ordersPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <>
            <ToastContainer autoClose={3000} />
            <Helmet>
                <title>{`${username} | Dashboard`}</title>
                <meta name="description" content={`user dashboard page of Shambasync`} />
            </Helmet>
            <div className='show-content'>
                <Dashboardmy />
                <div className="dashboard-main">
                    <div className="dashboard-top-section">
                        <div className="bg-card">
                            <div className="user-image">
                                <img src={userData.profile_image || user} alt="user" />


                            </div>
                            <div className='info-dashboard'> 
                                <div className="user-name">
                                    <span className="username">Name : {userData.name || 'User'}</span>
                                </div>
                                <div className="email-user">Email : {userData.email || 'No email provided'}</div>
                                <div className="phone-num">Phone : {userData.phone_number || 'No phone number provided'}</div>
                                {/* <span className="detail-user">Customer</span> */}       
                            </div>
                            <a className="profile" onClick={() => { navigate('/Nat') }}>Edit Profile</a>
                        </div>

                        <div className="billing-address-card">

                            <div className="title">Billing Address</div>

                            <div className="name">{userData.name || 'N/A'}</div>
                            {/* <FaRegAddressBook/> */}
                            <div className="address">
                                {userData.address.street ? (
                                    <>
                                        Street : {userData.address.street}<br />
                                        City : {userData.address.city}<br />
                                        State : {userData.address.state}<br />
                                        Country : {userData.address.country}<br />
                                        Zipcode : {userData.address.zip_code}<br />

                                    </>
                                ) : (
                                    'No address provided'
                                )}
                            </div>
                            {/* <div className="email-user">{userData.email || 'No email provided'}</div>
                            <div className="phone-num">{userData.phone_number || 'No phone number provided'}</div> */}
                            <div className="edit" onClick={() => { navigate('/address') }}>Edit Address</div>
                        </div>
                    </div>


                    <div className="order-history">
                        <div className="show-head p-2">
                            <h2>Recent Order History</h2>
                        </div>
                        {orders.length > 0 ? (
                            <>
                                {isMobile ? (
                                    <div className="mobile-orders">
                                        {currentOrders.map((order) => (
                                            <div key={order._id} className="mobile-order-card">
                                                <div className="mobile-order-row">
                                                    <span className="mobile-order-label">Order ID:</span>
                                                    <span className="mobile-order-value">{order._id.substring(0, 8)}...</span>
                                                </div>
                                                <div className="mobile-order-row">
                                                    <span className="mobile-order-label">Date:</span>
                                                    <span className="mobile-order-value">{formatDate(order.created_at)}</span>
                                                </div>
                                                <div className="mobile-order-row">
                                                    <span className="mobile-order-label">Status:</span>
                                                    <span className={`mobile-order-value status-badge ${getStatusClass(order.order_status)}`}>
                                                        {order.order_status}
                                                    </span>
                                                </div>
                                                <div className="mobile-order-row">
                                                    <span className="mobile-order-label">Payment:</span>
                                                    <span className="mobile-order-value">{order.payment_method}</span>
                                                </div>
                                                <div className="mobile-order-row">
                                                    <span className="mobile-order-label">Payment Status:</span>
                                                    <span className={`mobile-order-value status-badge ${getStatusClass(order?.cart_id?.payment_status)}`}>
                                                        {order?.cart_id?.payment_status}
                                                    </span>
                                                </div>
                                                {/* <button
                                                    className="mobile-view-order-btn"
                                                    onClick={() => { navigate(`/orderdetail?_id=${order._id}`) }}
                                                >
                                                    View Details
                                                </button> */}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <table className="order-table">
                                        <thead>
                                            <tr>
                                                <th>Order ID</th>
                                                <th>Date</th>
                                                <th>Status</th>
                                                <th>Payment Method</th>
                                                <th>Payment Status</th>
                                                {/* <th>Shipping</th> */}
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentOrders.map((order) => (
                                                <tr key={order._id}>
                                                    <td>{order.order_id}</td>
                                                    <td>{formatDate(order.created_at)}</td>
                                                    <td>
                                                        <span className={`status-badge ${getStatusClass(order.order_status)}`}>
                                                            {order.order_status}
                                                        </span>
                                                    </td>
                                                    <td>{order.payment_method}</td>
                                                    <td>
                                                        <span className={`status-badge ${getStatusClass(order?.cart_id?.payment_status)}`}>
                                                            {order?.cart_id?.payment_status}
                                                        </span>
                                                    </td>
                                                    {/* <td>{order.shipping}</td> */}
                                                    <td>
                                                        {/* <button
                                                            className="view-order-btn"
                                                            onClick={() => { navigate(`/order_view`) }}
                                                        >
                                                            View Details
                                                        </button> */}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}

                                {/* Pagination */}
                                <div className="pagination">
                                    <button
                                        className="page-btn"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        <HiOutlineChevronLeft />
                                    </button>
                                    {[...Array(totalPages)].map((_, index) => (
                                        <button
                                            key={index}
                                            className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            {index + 1}
                                        </button>
                                    ))}
                                    <button
                                        className="page-btn"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        <HiOutlineChevronRight />
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div className="no-orders">
                                <p>No orders found</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;
